import styles from "./SubmissionsPageText.module.css";
import { Link } from "react-router-dom";
import NavButton from "../components/shared/NavButton";
import ScrollTo from "react-scroll-into-view";
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/opacity.css';
import submissionImg from "../img/Submission/submissionImg.jpg";
import submissionImgPlaceholder from "../img/Submission/Placeholder/Placeholder_submissionImg.jpg";

function SubmissionsPageText() {
    return (
        <div className={styles.submissionsContainer}>
            <div className={styles.submissionsParagraphs}>
                <div className={styles.submissionsParagraph1} id="submissionsParagraph1">
                    <div className={styles.submissionsParagraphText}>
                        <p className={styles.paragraphNumber}>1/2</p>
                        <p>
                            Would you like to take part in this ongoing research project?
                        </p>
                        <div className={styles.submissionImgContainer}>

                            <LazyLoadImage src={submissionImg} placeholderSrc={submissionImgPlaceholder} effect="opacity" className={styles.submissionImg} alt={"Call Me By Your Meme vol.1"} />

                        </div>
                    </div>
                    <ScrollTo selector={`#submissionsParagraph2`}>
                        <p className={styles.paragraphDownButton}>»</p>
                    </ScrollTo>
                </div>
                <div className={styles.submissionsParagraphText} id="submissionsParagraph2">
                    <div className={styles.paragraphText}>
                        <br />
                        <br />
                        <br />
                        <br />
                        <p className={styles.paragraphNumber}>2/2</p>
                        <p>
                            Download the ‘virgin’ meme <a href="https://drive.google.com/drive/folders/1EO003e0bOFo1cz32ob_T1TJ82mz0ZFfR?usp=share_link" target="_blank" rel="noopener noreferrer">here</a>, make your mark, and send your submission to: <a href="mailto:CMBYMvol1@gmail.com?subject=Call Me By Your Meme vol.1 - Submission">CMBYMvol1@gmail.com</a>.
                        </p>
                        {/*<br />*/}
                        <br />
                        Selected works will be exhibited in the ‘Gallery’.
                    </div>
                </div>
            </div>
            <div className={styles.submissionsNavigationButtons}>
                <Link to="/about">
                    <NavButton navButtonLabel="About ›" />
                </Link>
                <Link to="/gallery">
                    <NavButton navButtonLabel="Gallery ›" />
                </Link>
                <Link to="/bibliography">
                    <NavButton navButtonLabel="Bibliography ›" />
                </Link>
                <Link to="/">
                    <NavButton navButtonLabel="Home ›" />
                </Link>
            </div>
        </div >

    )
}
export default SubmissionsPageText;